import { render, staticRenderFns } from "./NTLDstats.vue?vue&type=template&id=1504a085&"
import script from "./NTLDstats.vue?vue&type=script&lang=js&"
export * from "./NTLDstats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports